export class FPSMeter {
  static max = 60;
  cursor: number;
  measures: any[];
  fpsValues: number[];
  lastMeasureTime: number;

  constructor() {
    this.cursor = FPSMeter.max;
    this.measures = Array(FPSMeter.max + 2).fill(0);
    this.fpsValues = [];
    this.lastMeasureTime = Date.now();
    this.tick();
  }

  get cursor_next() {
    return (this.cursor + 1) % (FPSMeter.max + 1);
  }

  tick() {
    this.cursor = this.cursor_next;
    this.measures[this.cursor] = Date.now();

    if (Date.now() - this.lastMeasureTime >= 1000) {
      this.fpsValues.push(this.value);
      this.lastMeasureTime = Date.now();
    }

    requestAnimationFrame(() => this.tick());
  }

  get value() {
    const time = this.measures[this.cursor] - this.measures[this.cursor_next];
    return time ? Math.floor((FPSMeter.max * 1000) / time) : 0;
  }

  getMedianFPS() {
    if (this.fpsValues.length === 0) return 0;
    const sorted = [...this.fpsValues].sort((a, b) => a - b);
    const mid = Math.floor(sorted.length / 2);
    return sorted.length % 2 !== 0 ? sorted[mid] : (sorted[mid - 1] + sorted[mid]) / 2;
  }
}
